export default __webpack_public_path__ + "static/media/3031 spice rack E top.61f93ee0.png";